"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _mixins = _interopRequireDefault(require("./mixins"));
var _directives = _interopRequireDefault(require("./directives"));
var _default = exports.default = {
  name: 'wl-dialog',
  mixins: _mixins.default,
  directives: _directives.default,
  data: function data() {
    return {
      okBtnOption: {
        size: 'small',
        type: 'primary'
      },
      closeBtnOption: {
        size: 'small',
        type: ''
      },
      isInit: false,
      dialogOpenInit: {
        status: 'close',
        massageId: null
      }
    };
  },
  computed: {
    getDialogWidth: function getDialogWidth() {
      var _this$$attrs$width;
      return (_this$$attrs$width = this.$attrs.width) !== null && _this$$attrs$width !== void 0 ? _this$$attrs$width : '1000px';
    },
    computedDialogOptions: function computedDialogOptions() {
      return Object.assign(this.dialogOptions, {
        'append-to-body': true,
        'modal-append-to-body': false
      }, this.$attrs, this.dialogOptions);
    },
    dialogTool: function dialogTool() {
      var dialogTool = [];
      if (this.$attrs.canMax !== false) dialogTool.push('max');
      if (this.$attrs.canDrag !== false) dialogTool.push('drag');
      if (this.$attrs.canStretch !== false) dialogTool.push('stretch');
      return dialogTool;
    }
  },
  /* 数据监听 */
  watch: {
    open: {
      handler: function handler(nv) {
        this.dialogSwitch(nv);
      }
    },
    openDialog: {
      handler: function handler(nv) {
        this.dialogSwitch(nv);
      }
    }
  },
  methods: {
    init: function init() {
      if (this.openDialog !== this.open) this.openDialog = this.open;
    },
    /** 设置 dialog 样式
     * @description: 根据根标签的属性值 设置 dialog 的宽高
     * @return { void }
     */
    setDialogStyle: function setDialogStyle() {
      var _this = this;
      this.$$debounce(function () {
        var _this$$refs$wlDialog;
        var a = (_this$$refs$wlDialog = _this.$refs['wl-dialog']) === null || _this$$refs$wlDialog === void 0 ? void 0 : _this$$refs$wlDialog.$el;
        var b = a === null || a === void 0 ? void 0 : a.querySelector('.el-dialog');
        if (a && b) {
          ['width', 'height'].forEach(function (k1) {
            ['', 'min-', 'max-'].forEach(function (k2) {
              var c = a.getAttribute(k1 + k2);
              var d = b.style.cssText.includes(k1 + k2);
              if (c && !d) b.style.cssText += ";".concat(k1 + k2, ": ").concat(c * 1 ? 'px' : '', ";");
            });
          });
          b.style.cssText += ";height: auto;";
          if (!b.style['min-width']) b.style['min-width'] = '400px';
          if (!b.style['min-height']) b.style['min-height'] = '160px';
        }
      });
    },
    /** 设置 dialog 初始位置
     * @return { void }
     */
    setDialogInitPosition: function setDialogInitPosition() {
      var _this2 = this;
      this.$$debounce(function () {
        var _this2$$refs$wlDialo;
        var a = (_this2$$refs$wlDialo = _this2.$refs['wl-dialog']) === null || _this2$$refs$wlDialo === void 0 ? void 0 : _this2$$refs$wlDialo.$el;
        var b = a === null || a === void 0 ? void 0 : a.querySelector('.el-dialog');
        if (a && b) {
          // if ()
          // if (!b.style['max-width']) b.style['max-width'] = '100px'
          // if (!b.style['max-height']) b.style['max-height'] = '100px'
          var h1 = a.clientHeight - _this2.$$getDomSize(a, 'padding-top') - _this2.$$getDomSize(a, 'padding-bottom');
          var w1 = a.clientWidth - _this2.$$getDomSize(a, 'padding-left') - _this2.$$getDomSize(a, 'padding-right');
          b.style['max-width'] = "".concat(w1, "px");
          b.style['max-height'] = "".concat(h1, "px");
          b.style.cssText += ";position: absolute;top: ".concat(b.offsetTop, "px;left: ").concat(b.offsetLeft, "px;"); // height: ${b.offsetHeight}px;
        }
        _this2.setDialogInitPosition = function () {
          return null;
        };
      });
    },
    /** Dialog 打开的回调
     * @return { void }
     */
    onOpen: function onOpen() {
      var _this$dialogOpenInit$;
      this.dialogOpenInit.stauts = 'openLoading';
      (_this$dialogOpenInit$ = this.dialogOpenInit.massageId) === null || _this$dialogOpenInit$ === void 0 || _this$dialogOpenInit$.close();
      // this.dialogOpenInit.massageId = this.$message.warning('对话框打开中，请稍等')
      this.setDialogInitPosition();
      this.dialogOpen();
      this.$$listenersEmit('open');
    },
    /** Dialog 打开动画结束时的回调
     * @return { void }
     */
    onOpened: function onOpened() {
      var _this$dialogOpenInit$2;
      this.dialogOpenInit.stauts = 'open';
      (_this$dialogOpenInit$2 = this.dialogOpenInit.massageId) === null || _this$dialogOpenInit$2 === void 0 || _this$dialogOpenInit$2.close();
      this.$$listenersEmit('opened');
    },
    /** Dialog 关闭的回调
     * @return { void }
     */
    onClose: function onClose() {
      var _this$dialogOpenInit$3;
      this.dialogOpenInit.stauts = 'closeLoading';
      (_this$dialogOpenInit$3 = this.dialogOpenInit.massageId) === null || _this$dialogOpenInit$3 === void 0 || _this$dialogOpenInit$3.close();
      this.dialogClose();
      this.$$listenersEmit('close');
    },
    /** Dialog 关闭动画结束时的回调
     * @return { void }
     */
    onClosed: function onClosed() {
      var _this$dialogOpenInit$4;
      this.dialogOpenInit.stauts = 'close';
      (_this$dialogOpenInit$4 = this.dialogOpenInit.massageId) === null || _this$dialogOpenInit$4 === void 0 || _this$dialogOpenInit$4.close();
      this.$$listenersEmit('closed');
    },
    /** 点击确定按钮
     * @description: 点击确定按钮
     * @return { void }
     */
    onOk: function onOk() {
      this.$$listenersEmit('on-ok');
    },
    /** 打开对话框
     * @description: 打开对话框
     * @return { void }
     */
    dialogOpen: function dialogOpen() {
      this.openDialog = true;
      this.$emit('update:open', true);
    },
    /** 关闭对话框
     * @description: 打开对话框
     * @return { void }
     */
    dialogClose: function dialogClose() {
      this.openDialog = false;
      this.$emit('update:open', false);
    },
    /** 对话框开关
     * @description: 对话框开关
     * @param { Boolean } sw 打开或是关闭
     * @return { void }
     */
    dialogSwitch: function dialogSwitch(sw) {
      if (sw) this.dialogOpen();else this.dialogClose();
    }
  },
  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    this.openDialog = this.open;
    this.setDialogStyle();
  }
};